import theme from "@shared/utils/themeColors";
import ModalBlank from "../../../ui/modals/ModalBlank";

interface RestartTestModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isRestarting: boolean;
}

export default function RestartTestModal({
  isOpen,
  onClose,
  onConfirm,
  isRestarting,
}: RestartTestModalProps) {
  return (
    <ModalBlank
      id="restart-test-modal"
      modalOpen={isOpen}
      setModalOpen={onClose}
    >
      <div className="p-5 flex space-x-4">
        {/* Icon */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-gray-100 dark:bg-gray-700">
          <svg
            className={`shrink-0 fill-current ${theme.text.brand}`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
          </svg>
        </div>
        {/* Content */}
        <div>
          {/* Modal header */}
          <div className="mb-2">
            <div className={`text-lg font-semibold ${theme.text.primary}`}>
              Restart Test?
            </div>
          </div>
          {/* Modal content */}
          <div className="text-sm mb-10">
            <div className="space-y-2">
              <p>
                Are you sure you want to restart the test? All your progress
                will be reset.
              </p>
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className={`btn-sm ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300`}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              Cancel
            </button>
            <button
              className="btn-sm bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
              onClick={onConfirm}
              disabled={isRestarting}
            >
              {isRestarting ? "Restarting..." : "Yes, Restart"}
            </button>
          </div>
        </div>
      </div>
    </ModalBlank>
  );
}
